export default "__VITE_ASSET__DNU_8SCW__"